import { loadStripe, type Stripe } from "@stripe/stripe-js";
import { getStripePublishableKey } from "@/lib/stripe/config";

let cachedKey: string | null = null;
let cachedStripePromise: Promise<Stripe | null> | null = null;

function getStripePromise(): Promise<Stripe | null> | null {
  const publishableKey = getStripePublishableKey();

  if (!publishableKey) {
    cachedKey = null;
    cachedStripePromise = null;
    return null;
  }

  if (cachedKey !== publishableKey || cachedStripePromise === null) {
    cachedKey = publishableKey;
    cachedStripePromise = loadStripe(publishableKey);
  }

  return cachedStripePromise;
}

export { getStripePromise };
